import { createIsomorphicFn } from "@tanstack/react-start";
import { getRequestHeader } from "@tanstack/react-start/server";
import { normalizeSeoLocale, type SeoLocale } from "./seo";

const STORAGE_KEY = "lumen.lang";

/**
 * Resolves the language to use for page metadata.
 * Server: Accept-Language header. Client: stored preference, then browser.
 */
export const detectSeoLocale = createIsomorphicFn()
  .client((): SeoLocale => {
    let stored: string | null = null;
    try {
      stored = window.localStorage.getItem(STORAGE_KEY);
    } catch {
      stored = null;
    }
    return normalizeSeoLocale(stored ?? window.navigator.language);
  })
  .server((): SeoLocale => {
    try {
      return normalizeSeoLocale(getRequestHeader("accept-language"));
    } catch {
      return normalizeSeoLocale(null);
    }
  });
